// Build your character
import { GFX } from '../core/graphics';
import { SFX } from '../core/audio';
import { $ } from './dom';
import { setI } from './icons';
import { Store, type Profile } from '../core/store';
import { chOf, headImg, renderProfiles, type Character } from './profiles';
import { openMap } from './map';

// ---------- Build your character: animal, shirt, shoes ----------
const CH_ANIMALS = ['frog', 'fox', 'panda', 'tiger', 'cat', 'bunny'];
const CH_SHIRTS = ['#4A90E2', '#E94B4B', '#FFC93C', '#37C16B', '#9A6BE0', '#FF7FB6'];
const CH_SHOES = ['#E94B4B', '#4A90E2', '#FFC93C', '#3B2A5C', '#FFFFFF', '#37C16B'];
let chEdit: Profile | null = null, chDraft: Character;
export function openCreator(p: Profile | null) {
  chEdit = p; chDraft = Object.assign({}, p ? chOf(p) : { animal: CH_ANIMALS[Store.d.profiles.length % 6], shirt: CH_SHIRTS[Store.d.profiles.length % 6], shoes: CH_SHOES[(Store.d.profiles.length + 3) % 6] });
  const rowA = $('#chAnimals'), rowS = $('#chShirts'), rowF = $('#chShoes');
  rowA.innerHTML = ''; rowS.innerHTML = ''; rowF.innerHTML = '';
  CH_ANIMALS.forEach(an => {
    const b = document.createElement('button'); b.className = 'chopt'; b.dataset.v = an; b.innerHTML = headImg({ animal: an }, 64);
    b.addEventListener('click', () => { SFX.play('pick'); chDraft.animal = an; drawCreator(); }); rowA.appendChild(b);
  });
  CH_SHIRTS.forEach(c => { const b = document.createElement('button'); b.className = 'sw'; b.dataset.v = c; b.style.background = c;
    b.addEventListener('click', () => { SFX.play('pick'); chDraft.shirt = c; drawCreator(); }); rowS.appendChild(b); });
  CH_SHOES.forEach(c => { const b = document.createElement('button'); b.className = 'sw'; b.dataset.v = c; b.style.background = c;
    b.addEventListener('click', () => { SFX.play('pick'); chDraft.shoes = c; drawCreator(); }); rowF.appendChild(b); });
  drawCreator();
  $('#ovChar').hidden = false;
}
function drawCreator() {
  const c = $<HTMLCanvasElement>('#chPreview'), x = c.getContext('2d')!;
  x.setTransform(2, 0, 0, 2, 0, 0); x.clearRect(0, 0, 260, 340);
  GFX.char(x, chDraft, 130, 326, 300);
  for (const b of document.querySelectorAll<HTMLElement>('#chAnimals .chopt')) b.classList.toggle('on', b.dataset.v === chDraft.animal);
  for (const b of document.querySelectorAll<HTMLElement>('#chShirts .sw')) b.classList.toggle('on', b.dataset.v === chDraft.shirt);
  for (const b of document.querySelectorAll<HTMLElement>('#chShoes .sw')) b.classList.toggle('on', b.dataset.v === chDraft.shoes);
}
$('#chOk').addEventListener('click', () => {
  SFX.play('place');
  if (chEdit) chEdit.ch = chDraft;
  else { const p = { id: 'p' + Date.now(), ch: chDraft, prog: {}, intros: {}, fails: {} }; Store.d.profiles.push(p); Store.d.cur = p.id; }
  Store.save(); $('#ovChar').hidden = true;
  if (chEdit) renderProfiles(); else openMap();
});
$('#chCancel').addEventListener('click', () => { SFX.play('click'); $('#ovChar').hidden = true; });
setI($('#chOk'), 'check'); setI($('#chCancel'), 'back');
